import { render } from "./day-three-afternoon.vue?vue&type=template&id=2a68478a"
import script from "./day-three-afternoon.vue?vue&type=script&lang=js"
export * from "./day-three-afternoon.vue?vue&type=script&lang=js"
script.render = render

export default script